import { useQuery } from "@tanstack/react-query";
import { getRevenueEachStoreApi } from "../../services";
import { useAccountStore, useRevenueOverall } from "../../store";

export const useGetRevenueEachStoreApi = () => {
  const { accountId, endDate, startDate } = useRevenueOverall();
  const { info } = useAccountStore();

  const { data, isLoading } = useQuery({
    queryKey: ["revenue-revenue-each-store", startDate, endDate],
    queryFn: () => getRevenueEachStoreApi(startDate, endDate, info?.role === "ROLE_ADMIN" ? undefined : info?.id),
    enabled: !!startDate && !!endDate && !!info?.role,
  });
  return {
    revenueEachStore: data,
    isLoading,
  };
};
